import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ITaskStep } from '../interfaces/task-info';

@Injectable({ providedIn: 'root' })
export class TaskTypeService {
  private baseUrl: string = '/api/tasktypes';
  constructor(private http: HttpClient) {}

  get(): Promise<any> {
    return this.http.get(`${this.baseUrl}/get`).toPromise().catch();
  }

  getTaskTypeSteps(taskTypeId: number): Promise<ITaskStep[]> {
    return this.http.get<ITaskStep[]>(`${this.baseUrl}/steps/${taskTypeId}`).toPromise().catch();
  }
}
